import React from "react";
import PropTypes from "prop-types";
import { CloseOutlined } from "@ant-design/icons";
import GeneralButton from "../GeneralButton/GeneralButton";
import "./Dialog.css";

// ダイアログコンポーネント
function Dialog(props) {
  const { isOpen, onClose, title, children, buttons } = props;

  if (!isOpen) return null;

  return (
    <div className="dialog-overlay">
      <div className="dialog">
        <div className="dialog-header">
          <div className="dialog-title">{title}</div>
          <CloseOutlined
            onClick={onClose}
            className="dialog-close-icon"
            data-testid="close-icon"
          />
        </div>
        <div className="dialog-content">{children}</div>
        <div className="dialog-actions">
          {buttons &&
            buttons.map((button, index) => (
              <GeneralButton
                key={index}
                buttonLabel={button.label}
                width={button.width}
                size="min"
                type={button.type}
                onClick={() => button.onClick(index)}
              />
            ))}
        </div>
      </div>
    </div>
  );
}

// PropTypesを使ってプロパティの型を定義
Dialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
    })
  ),
};

export default Dialog;
